module.exports = __webpack_public_path__ + "static/media/right-icon.f7b97624.svg";